import { CrossWebAppRequest, getRefreshToken, removeTokens } from "@shapr3d/frontend-lib";
import { useMutation } from "@tanstack/react-query";

import { accountURL, marketingSiteURL, PostMessages } from "../config";
import { UMSrequestClient } from "../stores/requestClient";
import useTracker from "../utils/useTracker";

export const useLogout = (
  {
    redirect,
    withRequest,
    withUMCLogout,
  }: { redirect: boolean; withRequest: boolean; withUMCLogout: boolean } = {
    redirect: true,
    withRequest: true,
    withUMCLogout: true,
  }
) => {
  const tracker = useTracker();

  return useMutation({
    mutationKey: ["logout"],
    mutationFn: async () => {
      if (!withRequest) {
        return;
      }

      const refreshToken = getRefreshToken();

      if (!refreshToken) {
        return;
      }

      const logoutPromise = UMSrequestClient.publicRequest({
        method: "POST",
        url: "/auth/logout",
        extraHeaders: {
          Authorization: `Bearer ${refreshToken}`,
        },
      });

      if (withUMCLogout) {
        await CrossWebAppRequest({
          url: new URL(`${accountURL}/logout`),
          expectedPostMessageEventData: PostMessages.LogoutFinished,
        });
      }

      return logoutPromise;
    },
    onSettled: () => {
      tracker.reset();
      removeTokens();

      if (redirect) {
        window.location.assign(marketingSiteURL);
      }
    },
  });
};
